import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../baseurl";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import NavigateHome from "../../component/utils/NavigateHome";
import PageCount from "../../component/utils/PageCount";
import FooterTwo from "../../component/FooterTwo";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2500,
  timerProgressBar: true,
});

function AboutUser() {
  const [about, setAbout] = useState("");
  const [loading, setLoading] = useState(true);
  const [keywords, setKeywords] = useState("");
  const [generating, setGenerating] = useState(false);

  const maxChars = 500;
  const token = localStorage.getItem("token");

  // Load existing about info
  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const res = await axios.get(`${baseurl}getUserAbout`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setAbout(res.data.about?.slice(0, maxChars) || "");
      } catch (err) {
        console.error("Error fetching about info:", err);
      }
      setLoading(false);
    };
    fetchAbout();
  }, [token]);

  // Save about info
  const handleSaveAbout = async () => {
    try {
      await axios.post(
        `${baseurl}saveUserAbout`,
        { about },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      Toast.fire({ icon: "success", title: "About info saved!" });

      window.location.href = "/my-soulsathi";
    } catch (err) {
      console.error("Error saving about info:", err.response?.data || err);
      Toast.fire({ icon: "error", title: "Failed to save about info" });
    }
  };

  // Generate about using LLM API
const generateAbout = async () => {
  if (!keywords) {
    Toast.fire({ icon: "error", title: "Enter keywords first!" });
    return;
  }

  try {
    setGenerating(true);

    const res = await axios.post(
      `${baseurl}generateAbout`,
      { keywords },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setAbout(res.data.about || "");
    Toast.fire({ icon: "success", title: "About generated!" });

  } catch (err) {
    console.error("Error generating about:", err.response?.data || err);
    Toast.fire({ icon: "error", title: "Failed to generate about" });
  } finally {
    setGenerating(false);
  }
};

  if (loading) return <p className="text-center mt-4">Loading...</p>;

  return (
    <>
    <section className="section-about">
      <PageCount pageName = {"About User"}/>
      <NavigateHome/>
      <div className="about-container">
        <div className="text-end">
          <Link to="/my-soulsathi" className="btn btn-light btn-outline-secondary btn-sm" >Skip</Link>
        </div>
        <h2 className="text-center mb-4">About Yourself</h2>
        <p className="text-center text-muted mb-3">
          Write something interesting about yourself 
          {/* or generate automatically. */}
        </p>

        {/* <input
          type="text"
          placeholder="Enter keywords (e.g., friendly, foodie, traveler)"
          className="form-control mb-2"
          value={keywords}
          onChange={(e) => setKeywords(e.target.value)}
        />
        <button
          className="btn btn-secondary mb-3"
          onClick={generateAbout}
          disabled={generating}
        >
          {generating ? "Generating..." : "Generate About"}
        </button> */}

        <textarea
          value={about}
          onChange={(e) => {
            if (e.target.value.length <= maxChars) setAbout(e.target.value);
          }}
          placeholder="Write about yourself..."
          rows="7"
          className="form-control"
        />
        <div className="text-right text-muted mt-1">
          {about.length} / {maxChars}
        </div>

        <div className="text-center mt-4">
          <button className="btn btn-primary" onClick={handleSaveAbout}>
            Complete →
          </button>
          
        </div>
      </div>

      <style>{`
        .section-about { background: #fff7fa; padding: 40px 0; }
        .about-container {
          max-width: 600px;
          margin: auto;
          padding: 20px;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 0 15px rgba(0,0,0,0.08);
        }
        input.form-control {
          width: 100%;
          padding: 10px;
          border-radius: 8px;
          border: 1px solid #ccc;
          font-size: 14px;
        }
        textarea.form-control {
          width: 100%;
          padding: 12px;
          border-radius: 8px;
          border: 1px solid #ccc;
          font-size: 14px;
          resize: none;
        }
        .btn-primary, .btn-secondary {
          padding: 10px 25px;
          font-size: 16px;
          border-radius: 8px;
          margin-right: 5px;
        }
      `}</style>
    </section>

<FooterTwo />
    
    </>


  );
}

export default AboutUser;
